/**
 * modesService.js — Limited-time game modes catalog + live window.
 */
import { apiClient } from "./api";

export const modesService = {
  // 0-1 modes typically active at any moment.
  getActive: () => apiClient.get("/modes/active").then((r) => r.data),
  // Catalog of every defined mode + its next window. Used to render
  // an "Upcoming" preview when nothing's live right now.
  getAll: () => apiClient.get("/modes").then((r) => r.data),
};
